import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn, faToggleOff } from '@fortawesome/pro-light-svg-icons'

import GlobalContext from 'agency/digital_renderer/utils/context'
import { validateRenderConditions } from 'functions/replaceTextShortCodes'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import styles from './styles.scss'

const renderToggle = (editing, enabled, toggleSection) => {
  if (editing){
    return (
      <a className={styles.toggle} onClick={toggleSection} tabIndex="0">
        <FontAwesomeIcon icon={enabled ? faToggleOn : faToggleOff} className={styles.icon} />
      </a>
    )
  }

  return null
}

const Container = (props) => {
  const {
    callbacks: {
      updateCustomData,
    },
    children,
    context,
    id,
    options,
  } = props

  const {
    flexDirection, flexWrap, forceFlexDirection, renderConditions, toggleable,
  } = options

  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const contextData = context || defaultContext
  const { customData, editing } = defaultContext || {}

  // Hidden
  const itemData = customData[id] || {}
  const disabled = itemData.disabled || false

  const shouldRender = validateRenderConditions(renderConditions, contextData)

  if (!shouldRender || (!editing && disabled)) return null

  const toggleContainer = () => {
    if (updateCustomData){
      updateCustomData(id, {
        disabled: !disabled,
      })
    }
  }

  return (
    <AnimationWrapper options={options}>
      <div
        className={classnames(
          styles.root,
          flexDirection ? styles[flexDirection] : null,
          flexWrap ? styles[flexWrap] : null,
          forceFlexDirection ? styles.forceFlexDirection : null,
          disabled ? styles.disabled : null,
        )}
        style={style}
      >
        {children}
        {toggleable && renderToggle(editing, !disabled, toggleContainer)}
      </div>
    </AnimationWrapper>
  )
}

Container.propTypes = {
  callbacks: PropTypes.shape({
    updateCustomData: PropTypes.func,
  }),
  children: PropTypes.node,
  context: PropTypes.object,
  id: PropTypes.string.isRequired,
  options: PropTypes.object,
}

Container.defaultProps = {
  options: {},
}

export default Container
